import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["hasInlineStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { convertObjectToSingleString } from '../../../../../utils/helper';
import { IMAGE } from '../../../utils/editorStyles.constants';
export const getImageNode = props => ({
  inline: true,
  attrs: {
    src: {},
    alt: {
      default: null
    },
    title: {
      default: null
    },
    thumbUrl: {
      default: null
    },
    useThumbnail: {
      default: false
    },
    alignment: {
      default: 'wrap-inline'
    }
  },
  group: 'inline',
  draggable: true,
  parseDOM: [{
    tag: 'img[src]',
    getAttrs(dom) {
      return {
        src: dom.getAttribute('data-src') || dom.getAttribute('src'),
        thumbUrl: dom.getAttribute('data-thumbUrl') || '',
        title: dom.getAttribute('title'),
        alt: dom.getAttribute('alt')
      };
    }
  }],
  toDOM(node) {
    const {
      src,
      alt,
      title,
      useThumbnail,
      thumbUrl,
      alignment
    } = node.attrs;
    const {
        hasInlineStyles
      } = props,
      restProps = _objectWithoutProperties(props, _excluded);
    let domAttrs = {
      src: thumbUrl || src,
      alt,
      title,
      style: ''
    };
    if (src !== thumbUrl) domAttrs['data-thumbUrl'] = thumbUrl;
    if (useThumbnail) {
      domAttrs.width = '3rem';
      domAttrs.height = '3rem';
    }
    if (restProps) {
      domAttrs = _objectSpread(_objectSpread({}, domAttrs), restProps);
    }
    if (hasInlineStyles) {
      domAttrs.style = convertObjectToSingleString(IMAGE['default']);
    }
    if (IMAGE[alignment]) {
      const alignmentStyle = convertObjectToSingleString(IMAGE[alignment]);
      domAttrs.style += alignmentStyle;
    }
    return ['img', domAttrs];
  }
});